export enum IndicatorUpdateListOptions {
  My_Updates_Due = 1,
  All_Updates_Due = 2,
  Due_Next_30_days = 3,
  Recent_Updates = 4,
}
